import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const ShortCourseEditorActions = require('../../actions/ShortCourseEditorActions');
const ShortCourseEditorStore = require('../../stores/ShortCourseEditorStore');
const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');
const TemplateStore = require('../../stores/template_store_reflux');
const ActivityActions = require('../../actions/ActivityActions');
import Navigator from '../../Navigator';
import LoadingMainContent from '../loading/LoadingMainContent';
import WithShortCourseDoc from '../DataHOCs/WithShortCourseDoc';
import WithChannelActivities from '../DataHOCs/WithChannelActivities';
import WithChannelProjects from '../DataHOCs/WithChannelProjects';
import EditShortCourse from './EditShortCourse';
import { PreviewShortCourse } from './PreviewShortCourseView';
import TopNav from '../DashboardNew/Menu/TopNav';
import IFrame from '../IFrame';
import HelpDropdown from '../nav/HelpDropdown';

const _ = {
    cloneDeep:  require('lodash/cloneDeep'),
    map:        require('lodash/map'),
    find:       require('lodash/find'),
    forEach:    require('lodash/forEach'),
    isEqual:    require('lodash/isEqual'),
    get:        require('lodash/get'),
};

const propTypes = {
	shortCourse: PropTypes.object.isRequired,
	doc: PropTypes.object.isRequired,
    projectStoreState: PropTypes.shape({ initialized: PropTypes.bool, projects: PropTypes.array }).isRequired,
    activityStoreState: PropTypes.shape({ initialized: PropTypes.bool, activities: PropTypes.object }).isRequired,
};
const defaultProps = {};

class ReviewShortCourseView extends React.Component {
	constructor(props) {
		super(props);

		const { projects, activities, templates, pendingMetaData } = this.buildActivitySelectorData();
		ShortCourseEditorActions.initializeEditorDoc(uuid.v4(), this.props.doc,activities);
		this.buildActivitySelectorData = this.buildActivitySelectorData.bind(this); // required to ensure 'this' is available in first call

        let courseCommentInfo = ShortCourseStore.getState().courseCommentInfo[props.shortCourseId];
        let pendingCommentInfoId = null;
        if (!courseCommentInfo) {
            pendingCommentInfoId = uuid.v4();
            ShortCourseActions.getCommentInfo(pendingCommentInfoId,{shortCourseId:props.shortCourseId});
        }


		this.state = {
            projects,
            activities,
            templates,
            pendingMetaData,
			mode: 'EDIT',
            editedDoc: null, // this.props.doc,
			errorLines: [],
            courseCommentInfo, pendingCommentInfoId,
		};
	}
    
    componentDidMount() {
        this.unsubscribes = [
            ShortCourseEditorStore.listen(this.onEditedDocChange),
        ];
    }
    

    componentDidUpdate(prevProps) {
        if (this.props.projectStoreState.initialized && this.props.activityStoreState.initialized) {
            let activitySelectorChange = false;
            if (!prevProps.projectStoreState.initialized || !prevProps.activityStoreState.initialized) {
                activitySelectorChange = true;
            }
            else {
                if (!_.isEqual(prevProps.projectStoreState.projects, this.props.projectStoreState.projects)) {
                    activitySelectorChange = true;
                }
                else if (!_.isEqual(prevProps.activityStoreState.activities, this.props.activityStoreState.activities)) {
                    activitySelectorChange = true;
                }
            }

            if (activitySelectorChange) {
                let { projects ,activities , templates } = this.buildActivitySelectorData();
                this.setState({ projects, activities, templates });
            }
        }
    }

    componentWillUnmount() {
    	this.unsubscribes.forEach(u => u());
        delete this.unsubscribes; // in case we want to check if it's been unmounted
    }

    refreshComments=()=>{
        if (!this.state.pendingCommentInfoId) {
            let pendingCommentInfoId = uuid.v4();
            this.setState({pendingCommentInfoId});
            ShortCourseActions.getCommentInfo(pendingCommentInfoId,{shortCourseId:this.props.shortCourseId});
        }
    }
    
    commentAction=(commentAction)=>{
        let updateCommentActionId = uuid.v4();
        this.setState({updateCommentActionId},()=>{
            ShortCourseActions.updateComment(updateCommentActionId,{
                shortCourseId:this.props.shortCourseId,
                commentAction,
            });
        });
    }

    buildActivitySelectorData = () => {
        const curentStatePendingMetaData = _.get(this, ['state', 'pendingMetaData'], []); // required to ensure array since buildActivitySelectorData is called prior to state init in constructor
        const storeProjects = (this.props.projectStoreState && this.props.projectStoreState.initialized && this.props.projectStoreState.projects) || [];
        const storeActivities = (this.props.activityStoreState && this.props.activityStoreState.initialized && this.props.activityStoreState.activities) || {}; // keyed by project
        
        // flatten project out of activities and remove projects without any activities to choose from
        let projects = {};
        let activities = [];
        let need_full_info_ids = [];
        _.forEach(storeActivities, (projActivities, proj_id) => {
            let publishedActivities = [];
            _.forEach(projActivities,(activity) => {
                if (activity.ever_published && activity.latest_published_version) {
                    publishedActivities.push({
                        id: activity.id,
                        activity_id: activity.activity_id,
                        version: activity.latest_published_version,
                        project_id: activity.project_id,
                        template_id: activity.template_id,
                        title: activity.title,
                    });
                    if (
                        (
                            !activity.meta_data
                            || !activity.meta_data.saveDate
                            || (typeof activity.title === 'undefined')
                        )
                        && !curentStatePendingMetaData.find(getObj => getObj.activityId === activity.id) // TEMP hacky optimization to prevent duplicate activity requests. TODO rework this data fetching pattern
                    ) { // If there's not a saveDate, we don't have the full meta_data
                        // console.log(`requesting full info for activity`);
                        need_full_info_ids.push(activity.id);
                    }
                }
            });

            if (publishedActivities.length) {
                let p = _.find(storeProjects,{id:Number(proj_id)});
                projects[proj_id] = { name: p.name }; // that's all we need
                activities = activities.concat(publishedActivities);
            }

        });
        
        // massage templates into an object keyed by template_id
        const template_array = TemplateStore.getState().globalTemplates;
        let templates = {};
        _.forEach(template_array,(elem) => {
            templates[elem.id] = {
                name: elem.name,
                template_url: elem.template_url,
            }
        });
        
        let pendingMetaData = [];
        if (need_full_info_ids.length) {
            //console.log(`requesting full info for ${need_full_info_ids.length} activities`);
            _.forEach(need_full_info_ids,(activityId) => {
                let actionId = uuid.v4();
                ActivityActions.getActivity(actionId, {activityId});
                pendingMetaData.push({actionId,activityId});
            });
        }
        
        return {projects, activities, templates, pendingMetaData};
    }

    onClose = () => {
    	this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/short_course/${this.props.shortCourseId}`);
    }

    onEditedDocChange = (storeState) => {
        if (storeState.action) {
            if (storeState.action.error) {
                this.updateErrors(storeState.action.error);
            }
            else {
                switch(storeState.action.name) {
                    case 'initializeEditorDoc':
                    case 'selectNode':
                        break;
                    default:
                        //console.log(`action ${storeState.action.name} triggering unsavedChanges true`);
                        // unsavedChanges = true;
                }
            }
        }
        
        const editedDoc = storeState.shortCourseDoc;
        const selectedNode = _.find(editedDoc.nodes, { node_id: storeState.selectedNodeId });
        this.setState({ editedDoc, selectedNode });
    }

    onPreview = () => {
        this.setState({ mode: 'PREVIEW' });
    }

    onEdit = () => {
        this.setState({ mode: 'EDIT' });
    }

    onPreviewActivity = (activity_id) => {
        const cb = _.find(this.state.editedDoc.content_blocks, {nova_activity_id: activity_id });
        if (!cb) {
            console.log(`unable to find content block with activity id ${activity_id}`);
            return;
        }

        const activity = _.find(this.state.activities, { activity_id });
        if (!activity) {
            console.log(`unable to find activity id ${activity_id}`);
            return;
        }

        const template = this.state.templates[activity.template_id];
        if (!template) {
            console.log(`unable to find template id ${activity.template_id}`);
            return;
        }

        this.setState({
            iframe_url: `${template.template_url}/demo/web/${cb.nova_activity_id}/${cb.activity_version}`
        });
    }

    onCloseActivityPreview = () => {
        this.setState({ iframe_url: null });
    }
    
    noop=()=>{
    }

	render() {
        if (this.state.iframe_url) {
            return (
                <div className="short-course-editor">
                    <TopNav
                        onClickBrandLogo={Navigator.goToDashboardAuthorAuthoringChannelView.bind(this, this.props.history, this.props.channelId, null, { queryObj: { cType: Globals.content_type.COURSE }, addLeadingQuestionMark: true })}
                    >
                        <HelpDropdown />
                        <Button variant="light" className="editorButton margin-right-md" onClick={this.onCloseActivityPreview}>
                            Close Preview
                        </Button>
                    </TopNav>
                    <div className="preview-url">
                        <IFrame ref="iframe" url={this.state.iframe_url}/>
                    </div>
                </div>
            );
        }

		let mainContent;
        if (this.state.mode === 'EDIT') {
            if (!this.state.editedDoc) {
                mainContent = (
                    <div className="mzlIFrame--other">
                        <LoadingMainContent />
                    </div>
                );
            }
            else {
                mainContent = (
                    <EditShortCourse
                        channelId={this.props.channelId}
                        shortCourse={this.props.shortCourse}
                        projects={this.state.projects}
                        activities={this.state.activities}
                        templates={this.state.templates}
                        badgeTemplates={this.state.badgeTemplates}
                        editedDoc={this.state.editedDoc}
                        errorLines={this.state.errorLines}
                        selectedNode={this.state.selectedNode}
                        onPreviewActivity={this.onPreviewActivity}
                        onUpdateImage={this.noop}
                        onUpdateImageError={this.noop}
                        onRemoveImage={this.noop}
                        courseCommentInfo={this.state.courseCommentInfo}
                        refreshComments={this.refreshComments}
                        commentAction={this.commentAction}
                        reviewMode
                    />
                );
            }

        }
        else if (this.state.mode === 'PREVIEW') {
            mainContent = (
                <PreviewShortCourse
                    channelId={this.props.channelId}
                    projectId={this.props.projectId}
                    shortCourseId={this.props.shortCourseId}
                    shortCourse={this.props.shortCourse}
                    doc={this.state.editedDoc}
                    projectStoreState={this.props.projectStoreState}
                    activityStoreState={this.props.activityStoreState}
                    askToExitCourse={this.onEdit}
                />
            );
        }
        else {
            console.error('Invalid editor mode');
            mainContent = null;
        }

		return (
            <div className="short-course-editor">
                    <TopNav
                        onClickBrandLogo={Navigator.goToDashboardAuthorAuthoringChannelView.bind(this, this.props.history, this.props.channelId, null, { queryObj: { cType: Globals.content_type.COURSE }, addLeadingQuestionMark: true })}
                    >
                    {(this.state.mode === 'PREVIEW') &&
                        <Button variant="light" className="editorButton margin-right-md" onClick={this.onEdit}>
                            Edit
                        </Button>
                    }
                    {(this.state.mode === 'EDIT') &&
                        <Button variant="light" className="editorButton margin-right-md" onClick={this.onPreview}>
                            Preview
                        </Button>
                    }
                    {(this.state.mode === 'EDIT') &&
                        <Button variant="light" className="editorButton margin-right-md" onClick={this.onClose}>
                            Close
                        </Button>
                    }
                </TopNav>
                {mainContent}
            </div>
		);
	}
}

const WrappedComponent = withRouter(WithShortCourseDoc(WithChannelProjects(WithChannelActivities(ReviewShortCourseView))));

function WrappedComponentWithUpdatedPropNames(props) {
    return (
        <WrappedComponent
            {...props}
            shortCourseId={props.match.params.shortCourseId}
            projectId={props.match.params.projectId}
            channelId={props.match.params.channelId}
        />
    );
}

WrappedComponentWithUpdatedPropNames.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            channelId: PropTypes.string.isRequired,
            projectId: PropTypes.string.isRequired,
            shortCourseId: PropTypes.string.isRequired,
            shortCourseVersion: PropTypes.string,
        }).isRequired,
    }).isRequired,
};

export default WrappedComponentWithUpdatedPropNames;